var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-b lg:border-r col-span-1 flex items-center justify-center border-ds-outline-secondary pb-3 lg:p-0",class:_vm.className},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }